import React, {useState, useEffect } from 'react'; // eslint-disable-line
import style from './UserCombos.module.scss';
import SingleCombo from './singleCombo/SingleCombo';

const UserCombos = () => {

  const {
    userCombosContainer,
    listadoCombos,
    listaCombosContainer,
  } = style;
  
  return (
    <div className={ userCombosContainer }>
      <h1 className={ listadoCombos }>Listado de Combos</h1>
      <div className={ listaCombosContainer }>
        <SingleCombo />
      </div>
    </div>
  );
};

export default UserCombos;
